import APP_CONFIG from 'constants/clientConfigs'

export default function TrustedBrands() {
  const brands = APP_CONFIG[process.env.REACT_APP_CLIENT_ID].brands

  return (
    <div className="bg-white py-4 sm:py-8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2 className="text-center text-lg/8 font-semibold text-gray-900">
          Trusted by World’s best brands:
        </h2>

        <div className="mx-auto mt-10 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">
          {brands.map((brand, index) => (
            <img
              alt={brand.name}
              key={brand.name}
              src={brand.logo}
              width={158}
              height={48}
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
            />
          ))}
        </div>
      </div>
    </div>
  )
}
